import ServicePage from "./ServiceTemplate";
export default function DragonTendon() { return <ServicePage serviceId="dragon-tendon" />; }
